






























































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlNormalTxt from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlHimmoku from '@/components/common/search/CtrlHimmoku.vue';
import {
  HimmokuShuruiPtn,
  KaFukaFlg,
  ShoriKb,
  TaishoFlg,
  UmuFlg,
} from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import {
  calcAmount,
  calcWeight,
  convertStr2Num,
  dateStrToNum,
  isShorikbADD,
  isShorikbREFER,
  isShorikbUPD,
} from '@/utils/utils';
import moment from 'moment';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_020_JuchuEntry_ChildDetailInput',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
    CtrlNormalTxt,
    CtrlNumTxt,
    CtrlHimmoku,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
    childItem: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    BUTTON,
    UmuFlg,
    HimmokuShuruiPtn,
    TaishoFlg,
    KaFukaFlg,
    childDetailInput: {
      himmokuCd: 0,
      himmokuMei: '',
      tani: '',
      irisu: 0,
      juchuSuryo: 0,
      hasuSuryo: 0,
      juchuJuryo: 0,
      juchuTanka: 0,
      bubikiTanka: 0,
      juchuZeinukiKingaku: 0,
      meisaiBiko: '',
      himmokuBiko: '',
      mitsumoriTankaUmuFlg: 0,
      jotai: '',
    },
    himmokuItem: null,
    mounted: false,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    yearOfGenzaiYmd() {
      return Number(
        moment(this.userInfo.onlineData.genzaiYmd.toString()).format('YYYY')
      );
    },
    isAdd() {
      return isShorikbADD(this.shoriKb);
    },
    isRef() {
      return isShorikbREFER(this.shoriKb);
    },
    isUpd() {
      return isShorikbUPD(this.shoriKb);
    },
  },
  watch: {
    'childDetailInput.juchuSuryo': {
      async handler() {
        this.handleMitsumoriTanka();
        this.handleCalcAmount();
        this.handleCalcWeight();
      },
    },
    'childDetailInput.hasuSuryo': {
      handler() {
        this.handleCalcAmount();
        this.handleCalcWeight();
      },
    },
  },
  methods: {
    convertStr2Num,
    hide() {
      this.$emit('update:show', false);
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
    },
    initValues() {
      const { himmokuItem, ...childItem } = this.childItem;
      if (himmokuItem) {
        this.himmokuItem = himmokuItem;
      }
      this.childDetailInput = {
        ...this.childDetailInput,
        ...childItem,
      };
    },
    handleDelete() {
      this.hide();
      this.$emit('delete-item', this.childDetailInput);
    },
    async callbackOkHimmoku(item: any) {
      this.himmokuItem = item;
      if ((!this.mounted && !this.childDetailInput.isAddFromList) || this.isRef)
        return;
      if (item && item.himmokuCd) {
        this.childDetailInput.himmokuCd = item.himmokuCd;
        this.childDetailInput.himmokuMei = item.himmokuMei1 + (item.himmokuMei2 ? ' ' + item.himmokuMei2 : '');
        this.childDetailInput.tani = item.tani;
        this.childDetailInput.irisu = item.irisu;
        this.handleMitsumoriTanka();
        this.handleCalcAmount();
        this.handleCalcWeight();
      } else {
        this.himmokuItem = null;
        this.childDetailInput.himmokuCd = '';
        this.childDetailInput.tani = '';
        this.childDetailInput.irisu = 0;
        this.childDetailInput.himmokuBiko = '';
        this.childDetailInput.juchuTanka = 0;
        this.childDetailInput.juchuZeinukiKingaku = 0;
        this.childDetailInput.juchuJuryo = 0;
        this.childDetailInput.bubikiTanka = 0;
      }
    },
    handleCalcWeight() {
      if (
        (!this.mounted && !this.childDetailInput.isAddFromList) ||
        !this.himmokuItem
      )
        return;
      this.childDetailInput.juchuJuryo = calcWeight(
        this.himmokuItem.caseWeight ? this.himmokuItem.caseWeight : 0,
        convertStr2Num(this.childDetailInput.juchuSuryo),
        convertStr2Num(this.childDetailInput.hasuSuryo),
        this.himmokuItem.irisu ? this.himmokuItem.irisu : 0
      );
    },
    handleCalcAmount() {
      if (
        (!this.mounted && !this.childDetailInput.isAddFromList) ||
        !this.himmokuItem
      )
        return;
      const { juchuTanka, juchuSuryo, hasuSuryo, irisu, bubikiTanka } =
        this.childDetailInput;

      this.childDetailInput.juchuZeinukiKingaku = calcAmount(
        convertStr2Num(juchuTanka),
        convertStr2Num(juchuSuryo),
        convertStr2Num(hasuSuryo),
        convertStr2Num(irisu),
        convertStr2Num(bubikiTanka)
      );
    },
    async initHimmokuBiko() {
      const res = await this.$store.dispatch('common/getMitsumoriTanka', {
        jigyoshoCd: this.childDetailInput.juchuEntryJigyoshoCd,
        tokuisakiCd: this.childDetailInput.tokuisakiCd,
        nohinsakiCd: this.childDetailInput.nohinsakiCd,
        himmokuCd: this.childDetailInput.himmokuCd,
        haisoKb: this.childDetailInput.haisoKb,
        suryo: convertStr2Num(this.childDetailInput.juchuSuryo),
        targetYmd: dateStrToNum(this.childDetailInput.nohinKiboYmd),
      });
      if (res && res.data && res.data.responseData) {
        const { mitsumoriBiko } = res.data.responseData;
        this.childDetailInput.himmokuBiko = mitsumoriBiko;
      } else {
        this.childDetailInput.himmokuBiko = '';
      }
    },
    handleMitsumoriTanka() {
      if (
        (!this.mounted && !this.childDetailInput.isAddFromList) ||
        !this.himmokuItem
      )
        return;

        this.$store.dispatch('common/getMitsumoriTanka', {
          jigyoshoCd: this.childDetailInput.juchuEntryJigyoshoCd,
          tokuisakiCd: this.childDetailInput.tokuisakiCd,
          nohinsakiCd: this.childDetailInput.nohinsakiCd,
          himmokuCd: this.childDetailInput.himmokuCd,
          haisoKb: this.childDetailInput.haisoKb,
          suryo: convertStr2Num(this.childDetailInput.juchuSuryo),
          targetYmd: dateStrToNum(this.childDetailInput.nohinKiboYmd),
        })
        .then((res: any) => {
          if (res && res.data && res.data.responseData) {
            const { mitsumoriBiko, mitsumoriTanka, bubikiTanka } =
              res.data.responseData;
            this.childDetailInput.himmokuBiko = mitsumoriBiko;
            this.childDetailInput.juchuTanka = mitsumoriTanka;
            this.childDetailInput.bubikiTanka = bubikiTanka;
            this.childDetailInput.mitsumoriTankaUmuFlg = UmuFlg.ARI;
          } else {
            this.childDetailInput.himmokuBiko = '';
            this.childDetailInput.juchuTanka = 0;
            this.childDetailInput.bubikiTanka = 0;
            this.childDetailInput.mitsumoriTankaUmuFlg = UmuFlg.NASHI;
          }
        });
    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      if (!this.childDetailInput.himmokuCd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['品目'];
        this.messageShow = true;
        return;
      }
      if (
        !convertStr2Num(this.childDetailInput.juchuSuryo) &&
        !convertStr2Num(this.childDetailInput.hasuSuryo)
      ) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['c/s数量またはバラ数量'];
        this.messageShow = true;
        return;
      }
      if (
        convertStr2Num(this.childDetailInput.irisu) <
        convertStr2Num(this.childDetailInput.hasuSuryo)
      ) {
        this.messageId = 'KI_W104';
        this.messageTextParam = ['入数', 'バラ数量'];
        this.messageShow = true;
        return;
      }
      if (this.childDetailInput.mitsumoriTankaUmuFlg === UmuFlg.NASHI) {
        this.messageId = 'KI_W123';
        this.messageTextParam = ['見積単価が取得できない', '処理'];
        this.messageShow = true;
        return;
      }
      if (
        convertStr2Num(this.childDetailInput.juchuZeinukiKingaku) > 99999999
      ) {
        this.messageId = 'KI_W122';
        this.messageTextParam = ['金額'];
        this.messageShow = true;
        return;
      }
      if (convertStr2Num(this.childDetailInput.juchuJuryo) > 9999999.99) {
        this.messageId = 'KI_W122';
        this.messageTextParam = ['重量'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      const {
        himmokuCd,
        himmokuMei,
        tani,
        irisu,
        juchuSuryo,
        hasuSuryo,
        juchuJuryo,
        juchuTanka,
        bubikiTanka,
        juchuZeinukiKingaku,
        meisaiBiko,
        mitsumoriTankaUmuFlg,
      } = this.childDetailInput;
      const newItem = {
        himmokuCd,
        himmokuMei,
        tani,
        irisu: convertStr2Num(irisu),
        juchuSuryo: convertStr2Num(juchuSuryo),
        hasuSuryo: convertStr2Num(hasuSuryo),
        juchuJuryo: convertStr2Num(juchuJuryo),
        juchuZeinukiKingaku: convertStr2Num(juchuZeinukiKingaku),
        juchuTanka: convertStr2Num(juchuTanka),
        bubikiTanka: convertStr2Num(bubikiTanka),
        meisaiBiko,
        mitsumoriTankaUmuFlg,
        himmokuBiko: this.childDetailInput.himmokuBiko || '',
        ...(this.isUpd && {
          index: this.childDetailInput.index, // only Upd
        }),
      };
      this.hide();
      this.$emit('save-item', newItem);
    },
  },
  async created() {
    this.initValues();
    if (!this.isAdd) await this.initHimmokuBiko();
  },
  mounted() {
    this.$store.dispatch('common/setIsLoading', true);
    setTimeout(() => {
      this.mounted = true;
      this.$store.dispatch('common/setIsLoading', false);
    }, 1000);
  },
});
